import React, { useState, useEffect } from 'react';
import SingleColor from './SingleColor';

import Values from 'values.js';

function App() {
  const [color, setColor] = useState('');
  const [list, setList] = useState(new Values('#fff').all(10));
  const [error, setError] = useState(false);
  const [True, setTrue] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      let colors = new Values(color).all(10);
      setList(colors);
      console.log(colors);
      setError(false);
      setTrue(true);
    } catch (error) {
      console.log(error);
      setError(true);
      setTrue(false);
    }
  };

  useEffect(() => {
    const errorTimeOut = setTimeout(() => {
      setError(false);
    }, 3000);

    return () => {
      clearTimeout(errorTimeOut);
    };
  }, [error]);

  useEffect(() => {
    const TrueTimeOut = setTimeout(() => {
      setTrue(false);
    }, 3000);

    return () => {
      clearTimeout(TrueTimeOut);
    };
  }, [True]);

  return (
    <>
      <section className='container '>
        <h3>Generate color </h3>
        <form onSubmit={handleSubmit}>
          <input
            type='text'
            placeholder='#f3f2f1'
            value={color}
            onChange={(e) => {
              setColor(e.target.value);
            }}
            className={`${error ? 'error' : null} ${True ? 'true' : null}`}
          />
          <button className='btn' type='submit'>
            submit
          </button>
        </form>
      </section>
      <section className='colors'>
        {list.map((color, index) => {
          return (
            <SingleColor
              {...color}
              index={index}
              hexColor={color.hex}
            ></SingleColor>
          );
        })}
      </section>
    </>
  );
}

export default App;
